import { makeStyles } from '@cuda-networks/bds-core'

export default makeStyles({
  circularProgress: {
    marginBottom: 10
  },
  card: {
    border: 100
  }
})
